// extracted by mini-css-extract-plugin
export default {"container":"SearchTitle_container__vESlb","container__title":"SearchTitle_container__title__AFwDT","container__input":"SearchTitle_container__input__uQrDs"};